import { useDispatch } from "react-redux"
import styled from "styled-components"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import { useSelector } from "react-redux"
import TimeInput from "../shared/input/notification/TimeInput"
import { sendRegularMonthlyNotification, setIsLastDayOfMonthAccepted, setMonthDay } from "../../features/admin4/admin4Slice"
import Btn from "../shared/button/Btn"
import getNextMonthSameDayAndTime from "../../helper/notification/getNextMonthSameDayAndTime"
import InputCheckbox from "../shared/input/new/InputCheckbox"
import SmallSpinner from "../shared/spinners/SmallSpinner"

const Container = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;

    .month-day-container{
        position: relative;
        width: auto;
        height: auto;
        margin-bottom: 10px;

        .month-day-selected{
            width: 362px;
            height: 40px;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 15px;
            border-top-right-radius: 5px;
            border-top-left-radius: 5px;
        }
        
        .month-day-list{
            position: absolute;
            top: 40px;
            display: flex;
            flex-wrap: wrap;
            width: 362px;
            gap: 10px;
            background-color: ${({theme}) => theme.mainBgColor};
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-top: none;
            padding: 10px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            z-index: 10;

            .month-day-item{
                width: 40px;
                height: 30px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                border: 1px solid transparent;
                font-weight: var(--font-weight-md);

                &:hover{
                    border-color: ${({theme}) => theme.mainTextColor};
                }
            }

            .active{
                background-color: var(--color-main);
                color: #fff;
            }
        }
    }

    .checkbox-container{
        margin-bottom: 20px;
    }

    .time-container{
        position: relative;
        width: 250px;
        height: 40px;
        margin-bottom: 20px;
        
    }

`

const RegularMonthSelectContainer = ({isAll}) => {

    const dispatch = useDispatch()


    const {
        monthDay,
        notificationTitle,
        notificationText,
        notificationMenu,
        notificationSubMenu,
        mobileNotification,
        selectedPhoneNumbers,
        isLastDayOfMonthAccepted,
        timeData,
        monthDayWarningType,
        isLoadingSendRegularMonthlyNotification
    }= useSelector(state => state.admin4)

    const {
        activeSelect
    } = useSelector(state => state.layout)

    const handleClick = () => {

        if(!isAll){
            if(timeData.minute && timeData.hour && monthDay && notificationMenu.value && selectedPhoneNumbers.length > 0 && notificationTitle && notificationText){
            
                const body = {
                    scheduledTime: getNextMonthSameDayAndTime({day:monthDay, hour: timeData.hour, minute: timeData.minute}),
                    isRegular: true,
                    isRegularType: 0,
                    isLastDayOfMonth: monthDay < 29 ? false : isLastDayOfMonthAccepted,
                    isEveryone: false,
                    isMobileUser:true,
                    title: notificationTitle,
                    text: notificationText,
                    screenName: notificationSubMenu.value,
                    routeName:notificationMenu.value,
                    notificationAdded: mobileNotification,
                    scheduledNotificationRecipients: selectedPhoneNumbers.map(item => {
                        return {
                            phoneNumber: item.phoneNumber
                        }
                    })
                }

                dispatch(sendRegularMonthlyNotification(body))
            }
        }


        else{
            if(timeData.minute && timeData.hour && monthDay && notificationMenu.value && notificationTitle && notificationText){
            
                const body = {
                    scheduledTime: getNextMonthSameDayAndTime({day:monthDay, hour: timeData.hour, minute: timeData.minute}),
                    isRegular: true,
                    isRegularType: 0,
                    isLastDayOfMonth: isLastDayOfMonthAccepted,
                    isEveryone: true,
                    isMobileUser:true,
                    title: notificationTitle,
                    text:  notificationText,
                    screenName: notificationSubMenu.value,
                    routeName:notificationMenu.value,
                    notificationAdded: mobileNotification,
                }
    
                dispatch(sendRegularMonthlyNotification(body))
            }
        }
        
       
    }

    

  return (
    <Container>
        
        <div className="month-day-container">
            <div className="month-day-selected" onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === "month-day-selected") ? null : "month-day-selected"))}>{monthDay ? `Her ayın ${monthDay}. günü bildirim gönderilecek` : "Ayın hangi günü olduğunu seçiniz"}</div>
            {
                activeSelect === "month-day-selected" &&
                <div className="month-day-list">
                    {
                        Array.from({ length: 31 }).map((_, index) => (
                            <div className={monthDay === index+1 ? "active month-day-item" : "month-day-item"} onClick={() => dispatch(setMonthDay(index+1))}>{index+1}</div>
                        ))
                    }
                </div>
            }
        </div>

        <div className="checkbox-container">
            {
                monthDay > 28 &&
                <InputCheckbox data={isLastDayOfMonthAccepted} setData={(res) => dispatch(setIsLastDayOfMonthAccepted(res))} labelText={monthDayWarningType === 1 ? "Bazı aylar 31 çekmediği için, o ayların son gününde bildirim gönderilecektir." : monthDayWarningType === 2 && `Şubat ayı 28 çektiği için (önümüzdeki 4 yıl), Şubat ayının son günü bildirim gönderilecektir.`} borderSize="1px" fontWeight={"600"}/>
            }
        </div>

        <div className="time-container">
            <TimeInput inputWidth={"250px"}/>
        </div>

        <Btn bgColor="var(--color-main)" color="#fff" handleClick={handleClick} width={"250px"}>{isLoadingSendRegularMonthlyNotification ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : "Bildirim Gönder"}</Btn>

    </Container>
  )
}

export default RegularMonthSelectContainer